import {
    type AirportDto,
    AirportsApiAirportsGet,
    AirportsApiAirportsIataCodeFlightsGet,
    type FlightDto,
} from '@clients/FlightInfoApi';

export class FlightInfoStore {
    //#region state
    airports: AirportDto[] = [];
    inboundFlights: FlightDto[] = [];
    outboundFlights: FlightDto[] = [];
    //#endregion

    async fetchAirports(forceRefetch = false) {
        if (this.airports?.length && !forceRefetch) {
            return;
        }
        try {
            const { data } = await AirportsApiAirportsGet();
            this.airports = data.airports || [];
        } catch (e) {
            reportException(e);
        }
    }

    async fetchFlights(iataCode: string) {
        try {
            const { data } = await AirportsApiAirportsIataCodeFlightsGet({
                iataCode,
            });
            this.inboundFlights = data.inBoundFlights || [];
            this.outboundFlights = data.outBoundFlights || [];
        } catch (e) {
            reportException(e);
        }
    }
}

export const { use: useFlightInfoStore } = defineClassStore(
    'flightInfo',
    () => new FlightInfoStore()
);
